// src/pages/Payments.js
import { useEffect, useState } from 'react';
import API from '../api/axios';
import './Payments.css';

const Payments = () => {
  const [payments, setPayments] = useState([]);
  const [filter, setFilter] = useState('all');
  const [selected, setSelected] = useState(null);
  const [actionMsg, setActionMsg] = useState('');

  useEffect(() => {
    const params = {};
    if (filter !== 'all') params.status = filter;
    API.get('/payments', { params })
      .then(res => setPayments(res.data))
      .catch(console.error);
  }, [filter]);

  const openDetail = (id) => {
    API.get(`/payments/${id}`)
      .then(res => setSelected(res.data))
      .catch(console.error);
  };

  const doAction = async (id, action, body = {}) => {
    try {
      const res = await API.post(`/payments/${id}/${action}`, body);
      setActionMsg(res.data.message);
      setTimeout(() => setActionMsg(''), 3000);
      // Listeyi ve detayı güncelle
      const updated = await API.get('/payments', { params: filter !== 'all' ? { status: filter } : {} });
      setPayments(updated.data);
      if (selected) {
        const det = await API.get(`/payments/${selected.id}`);
        setSelected(det.data);
      }
    } catch (err) {
      setActionMsg(err.response?.data?.error || 'Hata oluştu');
    }
  };

  return (
    <div className="payments-page">
      <div className="page-header">
        <h1>💳 Payments</h1>
        <select className="filter-select" value={filter} onChange={e => setFilter(e.target.value)}>
          <option value="all">Tümü</option>
          <option value="confirmed">Onaylı</option>
          <option value="pending">Bekleyen</option>
          <option value="failed">Başarısız</option>
        </select>
      </div>

      {actionMsg && <div className="action-msg">{actionMsg}</div>}

      <div className="table-container">
        <table className="payments-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Kullanıcı</th>
              <th>Miktar</th>
              <th>Birim</th>
              <th>Durum</th>
              <th>Tarih</th>
              <th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {payments.map(p => (
              <tr key={p.id} onClick={() => openDetail(p.id)} style={{cursor:'pointer'}}>
                <td>#{p.id}</td>
                <td>@{p.member_username}</td>
                <td>{p.amount}</td>
                <td>{p.currency}</td>
                <td><span className={`status-tag ${p.status}`}>{p.status}</span></td>
                <td>{new Date(p.paid_at).toLocaleDateString('tr-TR')}</td>
                <td>
                  <button className="detail-btn" onClick={(e) => { e.stopPropagation(); openDetail(p.id); }}>
                    Detay
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selected && (
        <div className="detail-modal" onClick={() => setSelected(null)}>
          <div className="detail-content" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelected(null)}>×</button>
            <h2>Ödeme Detayı #{selected.id}</h2>
            <div className="detail-grid">
              <div><span>Kullanıcı:</span> @{selected.member_username}</div>
              <div><span>Telegram ID:</span> {selected.member_telegram_id}</div>
              <div><span>Paket:</span> {selected.package_name}</div>
              <div><span>Miktar:</span> {selected.amount} {selected.currency}</div>
              <div><span>Durum:</span> <span className={`status-tag ${selected.status}`}>{selected.status}</span></div>
              <div><span>Ödeme Tarihi:</span> {new Date(selected.paid_at).toLocaleString('tr-TR')}</div>
              <div><span>Üye Durumu:</span> {selected.member_status}</div>
            </div>
            <div className="action-buttons">
              <button onClick={() => doAction(selected.id, 'verify')}>🔄 Doğrula</button>
              <button onClick={() => doAction(selected.id, 'reprocess')}>♻️ Yeniden İşle</button>
              <button onClick={() => {
                const note = prompt('İnceleme notu:');
                if (note) doAction(selected.id, 'flag', { note });
              }}>🚩 İncelemeye Al</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Payments;